import CreatePasswordBlock, { CreatePasswordBlockProps } from './CreatePasswordBlock';
import withInteractor from './CreatePasswordBlock.interactor';
import withPresenter from './CreatePasswordBlock.presenter';
export type { CreatePasswordBlockProps };

export default withInteractor(withPresenter(CreatePasswordBlock));

